export default {
    'sesstoken':'/sesstoken',
    'login':'/profile/login',
    'wakeup':'/profile/getInfo',
    'sendCode':'/profile/sendCode',
    'dialogs':'/support/manager/dialogs',
    'dialogs/create':'/support/manager/dialogs/create',
    'messages':'/support/manager/dialogs/messages',
    'messages/create':'/support/manager/dialogs/messages/create',
}